export class TenderPeriodEntity {
  public POPNUMCYC: string = '';
  public PKGPPCYC: string = '1';
  public EXFLISTP: string = '';
  public CLAWBACK: string = '0';
  public PRCDISC: string = '';
  public PRCCUT: string = '0';
  public PRCCONFIDDISCCYC: string = '0';
  // This one is for EC
  public EXCAP: string = '';
  public REIMBGROSSCYC: string = '';
  // This one is for FCPP
  public FCPPC: string = '';
  // This one is for UC
  public PSUALU: string = '';
  public PVA_V = [];
  public PVA_S = [];
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/entities/tender-period-entity.ts